import * as React from "react";
import { holdSecNavOptions, EHoldScreenState, holdNote } from "../holdConstants";
import HoldTotalBlock, { IHoldTotalBlockProps } from "../generic/holdTotalBlock";
import { useRouteMatch, Link } from "react-router-dom";
import { IHoldRouteParams } from "../../../types/components/holdings/holdTypes";
import Tab from "../../../generic/tab";
import NoDataContainer from "../../../generic/noDataContainer";
import Loader from "../../../generic/loader";
import TocNoteTab from "../../../toc/generic/tocNote/tocNoteTab";
import "../../../../assets/scss/components/generic/layout/layoutTab.scss";
import "../../../../assets/scss/components/toc/holdings/holdingsTab.scss";

export interface IHoldLayoutTabProps {
	totalBlockData: IHoldTotalBlockProps;
	screenState: EHoldScreenState;
}

const HoldLayoutTab: React.FC<IHoldLayoutTabProps> = props => {
	const routeParams = useRouteMatch<IHoldRouteParams>();
	const [isFixed, setIsFixed] = React.useState<boolean>(false);

	function onContainerScroll(e: React.UIEvent<HTMLElement>) {
		// console.dir((e.target as HTMLElement).scrollTop);
		// if scrolltop is greater than 78 then fix the header
		(e.target as HTMLElement).scrollTop > 40 ? !isFixed && setIsFixed(true) : isFixed && setIsFixed(false);
	}

	return (
		<section className={"outer_container container_tab hold_container_tab" + (isFixed ? " hold_scroll_active" : "")}>
			<section className="lyCont">
				<section className="holding_tab">
					<div className="mrgn_hdr_tab">
						<Tab defaultValue={routeParams.url.split("/")[2] || "equity"} tabList={holdSecNavOptions} position="center" />
						<div className="detailed_holdings_cont">
							<Link to="#" className="detailed_holdings">
								<TocNoteTab>{holdNote}</TocNoteTab>
								<span>
									Detailed Holdings <i className="edel-icon-arrow-right " />
								</span>
							</Link>
						</div>
					</div>
					{props.screenState === EHoldScreenState.DATA && (
						<div>
							<div className="hld_hdr_tab">
								<HoldTotalBlock {...props.totalBlockData} />
							</div>
							<div className="hld_cont_tab" onScroll={onContainerScroll}>
								<div className="hld_dtls_tab">{props.children}</div>
							</div>
						</div>
					)}
					{props.screenState === EHoldScreenState.NO_DATA && (
						<div>
							<NoDataContainer txtHeading="Lorem Ipsum Dolor sit amet Consecutor" txtSubHeading="" />
						</div>
					)}
					{props.screenState === EHoldScreenState.LOADING && (
						<div className="hold_loader_cont">
							<Loader size={20} color="blue" />
						</div>
					)}
				</section>
			</section>
		</section>
	);
};

export default HoldLayoutTab;
